$('body').on('change', '#publish_category_id', function () {
    $.ajax({
        url: $(this).attr('data-action'),
        type: $(this).attr('data-method'),
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        data: {
            category_id: $(this).val()
        },
        dataType: 'JSON',
        success: function (data) {
            $('#subcategory_id').html(data.html);
        }
    });
    $('#subcategory_id').html();

    let specialCategoryCard = $('#special_category_card_' + $(this).val());
    $('.special_category_card').addClass('d-none');
    $('.special_category_card input, .special_category_card textarea, .special_category_card select').val('');
    if (specialCategoryCard.length > 0) {
        specialCategoryCard.removeClass('d-none');
    }
});

$('body').on('change', '#search_category_id', function () {
    $('#search_subcategory_id').html('');
    $.ajax({
        url: $(this).attr('data-action'),
        type: $(this).attr('data-method'),
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        data: {
            category_id: $(this).val()
        },
        dataType: 'JSON',
        success: function (data) {
            $('#search_subcategory_id').html(data.html);
        }
    });
});

if ($('#publish_price_1').length > 0) {
    $('#publish_price_1').maskMoney({
        prefix: '',
        suffix: '€',
        decimal: '.',
        thousands: ' '
    });
    $('#publish_price_2').maskMoney({
        prefix: '',
        suffix: '€',
        decimal: '.',
        thousands: ' '
    });
}

$('body').on('change', '#publish_price_type', function () {
    let value = parseInt($(this).val());
    let price1Wrapper = $('#publish_price_1_wrapper');
    let price2Wrapper = $('#publish_price_2_wrapper');
    let price1Label = $('#publish_price_1_label');
    let price2Label = $('#publish_price_2_label');
    let price1Input = $('#publish_price_1');
    let price2Input = $('#publish_price_2');

    if (value === 0) {
        price1Wrapper.addClass('d-none');
        price2Wrapper.addClass('d-none');
        price1Input.prop('required', false);
        price2Input.prop('required', false);
    }
    if (value === 1) {
        price1Input.prop('required', true);
        price1Label.text('Preço Fixo');
        price1Label.addClass('required');
        price2Input.prop('required', false);
        price2Wrapper.addClass('d-none');
        price1Wrapper.removeClass('d-none');
        price1Input.attr('placeholder', 'Preço Fixo')
    }
    if (value === 2) {
        price1Input.prop('required', true);
        price2Input.prop('required', true);
        price1Label.text('Preço Mínimo');
        price1Label.addClass('required');
        price2Label.addClass('required');
        price1Wrapper.removeClass('d-none');
        price2Wrapper.removeClass('d-none');
        price1Input.attr('placeholder', 'Preço Mínimo')
    }
})

$('body').on('focusout', '#publish_zip', function () {
    $.ajax({
        url: $(this).attr('data-url'),
        type: 'POST',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        data: {
            cp7: $(this).val()
        },
        dataType: 'JSON',
        success: function (data) {
            $('#publish_city').val(data.city);
        }
    });
});

$('body').on('click', '#publish_geolocation', function () {
    $.ajax({
        url: $(this).attr('data-action'),
        type: 'POST',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        data: {
            latitude: window.geolocation.latitude,
            longitude: window.geolocation.longitude
        },
        dataType: 'JSON',
        success: function (data) {
            $('#publish_city').val(data.city);
            $('#publish_zip').val(data.zip);
        }
    });
});

/* Ad Gallery Delete */
$('body').on('click', '.ad-delete-image', function () {
    let id = $(this).attr('data-id');
    let formEl = $('#ad_gallery_delete_form');
    let formInputEl = $('#ad_gallery_delete_id');

    formInputEl.val(id);
    formEl.submit();
});

/* Ad Document Delete */
$('body').on('click', '.ad-delete-document', function () {
    let id = $(this).attr('data-id');
    let formEl = $('#ad_document_delete_form');
    let formInputEl = $('#ad_document_delete_id');

    formInputEl.val(id);
    formEl.submit();
});

/* Ad Video Delete */
$('body').on('click', '.ad-delete-video', function () {
    let id = $(this).attr('data-id');
    let formEl = $('#ad_video_delete_form');
    let formInputEl = $('#ad_video_delete_id');

    formInputEl.val(id);
    formEl.submit();
});


$('#pickup_city').autocomplete({
    serviceUrl: $('#pickup_city').attr('data-url'),
    dataType: 'json'
});

$('#delivery_city').autocomplete({
    serviceUrl: $('#delivery_city').attr('data-url'),
    dataType: 'json'
});

$('#ad-title-input').mask('Procuro ##############################################################', {
    translation: {
        //'#': {pattern: /[a-zA-Z]|[à-ú]|[À-Ú]|[a-zA-Z0-9 ]/},
        '#': {pattern: /./}, // Accept any character
    }
});

$('#ad-title-input').on('keyup', function (e) {
    let val = $(this).val().replace('Procuro ', '');

    $(this).val('Procuro ' + val);
})


$('body').on('click', '#adPublish_useHomeAddress', function (e) {
    e.preventDefault();
    let data = JSON.parse($(this).attr('data-json'));
    $('#publish_city').val(data.city);
    $('#publish_zip').val(data.zip);
})
